import { render, staticRenderFns } from "./ContactLabels.vue?vue&type=template&id=6af5988d&"
import script from "./ContactLabels.vue?vue&type=script&lang=js&"
export * from "./ContactLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports